import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  camerasList: {
    data: [],
    total: 0,
  },
};

const camerasSlice = createSlice({
  name: "cameras",
  initialState,
  reducers: {
    setCamerasList: (state, action) => {
      state.camerasList = action.payload;
    },
  },
});

export const { setCamerasList } = camerasSlice.actions;
export default camerasSlice.reducer;